<button class="close-button" mat-icon-button (click)="close()">
  <mat-icon>close</mat-icon>
</button>
<div class="active-orders-container">
  <div class="message">{{ 'YOU_HAVE_WAITING_ORDERS' | transloco }}</div>
  <div class="action-container">
    <button class="button" mat-raised-button (click)="goToOrders()">{{ 'Voir mes commandes' | transloco }}</button>
  </div>
</div>
